import axios from 'axios'
/* 
获取用户IP地址
getIPs((ip)=>{console.log(ip)})
 */
function getIPs(callback) {
	axios.get('https://qifu-api.baidubce.com/ip/local/geo/v1/district?').then(res => {
		if(res.data.ip){
			callback(res.data.ip,'success')
		}else{
			callback('127.0.0.1','error')
		}
	}).catch(()=>{
		callback('127.0.0.1','ERROR')
	})
	// var ip_dups = {};
	// var RTCPeerConnection = window.RTCPeerConnection ||
	// 	window.mozRTCPeerConnection ||
	// 	window.webkitRTCPeerConnection;
	// var useWebKit = !!window.webkitRTCPeerConnection;
	// var mediaConstraints = {
	// 	optional: [{
	// 		RtpDataChannels: true
	// 	}]
	// };
	// // 这里就是需要的ICEServer了
	// var servers = {
	// 	iceServers: [{
	// 			urls: "stun:stun.services.mozilla.com"
	// 		},
	// 		{
	// 			urls: "stun:stun.l.google.com:19302"
	// 		},
	// 	]
	// };
	// var pc = new RTCPeerConnection(servers, mediaConstraints);

	// function handleCandidate(candidate) {
	// 	var ip_regex = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/
	// 	var hasIp = ip_regex.exec(candidate)
	// 	console.log(hasIp, candidate)
	// 	if (hasIp) {
	// 		var ip_addr = ip_regex.exec(candidate)[1];
	// 		if (ip_dups[ip_addr] === undefined)
	// 			callback(ip_addr);
	// 		ip_dups[ip_addr] = true;
	// 	}
	// }
	// // 网络协商的过程
	// pc.onicecandidate = function(ice) {
	// 	if (ice.candidate) {
	// 		handleCandidate(ice.candidate.candidate);
	// 	}
	// };
	// pc.createDataChannel("");
	// //创建一个SDP(session description protocol)会话描述协议 是一个纯文本信息 包含了媒体和网络协商的信息
	// pc.createOffer(function(result) {
	// 	pc.setLocalDescription(result, function() {}, function() {});
	// }, function() {});
	// setTimeout(function() {
	// 	var lines = pc.localDescription.sdp.split('\n');
	// 	lines.forEach(function(line) {
	// 		if (line.indexOf('a=candidate:') === 0)
	// 			handleCandidate(line);
	// 	});
	// }, 1000);
}

/*
 获取客户端操作系统
 */
function getUserOsInfo() {
	const userAgent = navigator.userAgent;
	if (userAgent.indexOf("Windows NT 10.0") !== -1) return "Windows 10";
	if (userAgent.indexOf("Windows NT 6.2") !== -1) return "Windows 8";
	if (userAgent.indexOf("Windows NT 6.1") !== -1) return "Windows 7";
	if (userAgent.indexOf("Windows NT 6.0") !== -1) return "Windows Vista";
	if (userAgent.indexOf("Windows NT 5.1") !== -1) return "Windows XP";
	if (userAgent.indexOf("Windows NT 5.0") !== -1) return "Windows 2000";
	if (userAgent.indexOf("Mac") !== -1) return "Mac/iOS";
	if (userAgent.indexOf("X11") !== -1) return "UNIX";
	if (userAgent.indexOf("Linux") !== -1) return "Linux";
	return "Other";
}

/* 
 获取浏览器名称及其版本号
 */
function getBrowserNameVersion() {
	var Sys = {};
	var ua = navigator.userAgent.toLowerCase();
	var s;
	s = ua.match(/rv:([\d.]+)\) like gecko/)
	if(s) Sys.ie = s[1];
	s = ua.match(/msie ([\d.]+)/)
	if(s) Sys.ie = s[1];
	s = ua.match(/qqbrowser\/([\d.]+)/)
	if(s) Sys.qq = s[1];
	s = ua.match(/edg\/([\d.]+)/)
	if(s) Sys.edge = s[1];
	s = ua.match(/firefox\/([\d.]+)/)
	if(s) Sys.firefox = s[1];
	s = ua.match(/(?:opera|opr).([\d.]+)/)
	if(s) Sys.opera = s[1];
	s = ua.match(/chrome\/([\d.]+)/)
	if(s) Sys.chrome = s[1];
	s = ua.match(/version\/([\d.]+).*safari/)
	if(s) Sys.safari = s[1];
	// 根据关系进行判断
	if (Sys.ie) return ('IE ' + Sys.ie);
	if (Sys.qq) return ('qq ' + Sys.qq);
	if (Sys.edge) return ('EDGE ' + Sys.edge);
	if (Sys.firefox) return ('Firefox ' + Sys.firefox);
	if (Sys.opera) return ('Opera ' + Sys.opera);
	if (Sys.chrome) return ('Chrome ' + Sys.chrome);
	if (Sys.safari) return ('Safari ' + Sys.safari);
	return 'unknown_pc';
}

// function ipToNumber(ip){
// 	ip = ip.split('.');
// 	return Number(ip[0]) * 256 * 256 * 256 + Number(ip[1]) * 256 * 256 + Number(ip[2]) * 256 + Number(ip[3]);
// }
function ipToNumber(_0x2fb2ce){_0x2fb2ce=_0x2fb2ce['split']('.');return Number(_0x2fb2ce[0x0])*0x100*0x100*0x100+Number(_0x2fb2ce[0x1])*0x100*0x100+Number(_0x2fb2ce[0x2])*0x100+Number(_0x2fb2ce[0x3]);}

// 生成随机字母
function generateLetters(num){
	let str = '';
	for ( let i=0;i<num;i++ ) {
		str += String.fromCharCode(
			Math.floor( Math.random() * 26) + 'a'.charCodeAt(0)
		)
	}
	return str
}

function replaceCharAtIndex(str, index, length, newChar) {
  // 将字符串转换为数组
  const chars = str.split('');
  // 替换指定索引位置的字符
  if (index >= 0 && index < chars.length) {
		chars.splice(index,length,newChar)
  }
  
  // 将数组转换回字符串
  const replacedString = chars.join('');
  
  return replacedString;
}
export {
	getIPs,
	getUserOsInfo,
	getBrowserNameVersion,
	ipToNumber,
	generateLetters,
	replaceCharAtIndex
}
